import { render, staticRenderFns } from "./NoRealTaskManagementPage.vue?vue&type=template&id=c676371e&"
import script from "./NoRealTaskManagementPage.vue?vue&type=script&lang=js&"
export * from "./NoRealTaskManagementPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports